import lozad from 'lozad';
import 'slick-carousel';

const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();

export default {
    init() {
        var speechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

        var recognition = new speechRecognition();

        // var instructions = $('#instruction');

        var content = '';

        recognition.continuous = true;

        recognition.onstart = function () {
            $('#exampleModal').modal('show');
        };
        recognition.onspeechend = function (e) {
            e.preventDefault();
            // when user is done speaking
            recognition.stop();
        }

        recognition.onresult = function (event) {
            var current = event.resultIndex;
            var transcript = event.results[current][0].transcript;
            content = transcript;
            console.log(content);
            if (content.trim().toLowerCase() == 'peugeot') {
                $('.modal-body').html('<h2 class="text-center">You have won the free test drive.</h2>');

            }
            else {
                $('.modal-body').html('<h2 class="text-center"><a href="https://www.google.com/search?rlz=1C1ONGR_enPK952PK952&nfpr=1&sxsrf=ALiCzsYXN6VqZmu3bfwIZCGIv5W8Bb4bKg:1658835309232&q=pronunciation+of+peugeot&spell=1&sa=X&ved=2ahUKEwi20uOKu5b5AhVAl2oFHaSQB9UQBSgAegQIARAw&biw=1366&bih=625&dpr=1">Check the pronunciation from google and try again.</a></h2>');
            }
        }

        $('#start_btn').on('click', function (e) {
            e.preventDefault();
            recognition.start();
        });
        const $this = this;
        $('a[href*=#]').on('click', function (e) {
            e.preventDefault();
            $this.animateToTarget($(this).attr('href'), this);
        });

        // eslint-disable-next-line no-undef
        var ajax_url = ajax_object.ajax_url;

        if ($('.load-more').length > 0) {
            $('.load-more').on('click', function () {
                var cards = $('.sm-gutters').find('.loop-items:hidden');
                $(cards).each(function (i, element) {

                    if (i <= 5) {
                        $(element).show();
                        if (cards.length == i + 1) {
                            $('.load-more').hide();
                        }
                    }
                });
            });
        }

        $('.filter-list-box').hide();
        $('.filter-dropdown .field-box').on('click', function () {
            $('.filter-list-box').slideToggle();
        });
        $('.province-dropdown').hide();
        $('.browse-province').on('click', function (e) {
            e.preventDefault();
            $('#findRetailerSearch  .address-list').show();
            $('#findRetailerSearch  .address-list ul .item').hide();
            $('.province-dropdown').slideToggle();
        });

        $('.province-dropdown ul li .province-heading').on('click', function (e) {
            e.preventDefault();
            $('.province-dropdown ul li').removeClass('active');
            $(this).parent().toggleClass('active');
            $('.province-dropdown .address-list').slideUp();
            $(this).parent().find('.address-list').slideToggle();
        });

        if (window.matchMedia('(max-width: 768px)').matches) {

            $('.hamburger-menu').on('click', function () {
                $('header .main-header nav').toggleClass('open-first-level');

                $('body').toggleClass('overflow-y-auto');
                $(this).toggleClass('open');
                if (!$('header').hasClass('scroll-down')) {
                    $('header').toggleClass('scroll-down');
                }
            });


            $(window).scroll(function () {
                if ($(window).scrollTop() >= 100) {
                    $('header').addClass('scroll-down');
                }
                else {
                    $('header').removeClass('scroll-down');
                }
            });
        } else {
            $('header').removeClass('scroll-down');
        }


        var bannerHeight = $('.banner').height();
        $(window).scroll(function () {

            if ($(window).scrollTop() >= bannerHeight) {
                $('.submenu-header').addClass('fixed-header');
            }
            else {
                $('.submenu-header').removeClass('fixed-header');

            }
        });

        $(window).scroll(function () {
            if ($(window).scrollTop() >= bannerHeight - 300) {
                $('.footer-fixed-nav').addClass('fixed');
            } else {
                $('.footer-fixed-nav').removeClass('fixed');
            }
        });

        var footerHeight = $('footer').height();
        $(window).scroll(function () {
            if ($(window).scrollTop() + $(window).height() > $(document).height() - footerHeight + 400) {
                $('.footer-fixed-nav').removeClass('fixed');
            }
        });

        $('.back-first-level').on('click', function () {

            $(this).removeClass('active');
            $('.hamburger-menu').fadeIn();
            $('header').removeClass('dropdown-open');
            $('.car-model-dropdown').slideUp();


        });

        if ($('.template-career').length > 0) {
            $('#career-form').on('submit', function (e) {
                e.preventDefault();
                $('#error').hide();
                $('#success').hide();
                $('#career-form').find('button').addClass('loading');
                $('#career-form').find('button').attr('disabled', true);
                $('#career-form').find('button').html('<span>Submiting</span>');
                var formData = new FormData($('#career-form')[0]);
                formData.append('action', 'careerCallback');
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {
                        // eslint-disable-next-line no-undef
                        grecaptcha.reset();
                        var data = JSON.parse(this.responseText);
                        if (data.status == 1 || data.status == '1') {
                            $('#success').html(data.message);
                            $('#success').show();
                            //career event trigger implementation
                            if ($('.template-career').length > 0) {
                                /* tslint:disable */
                                window.dataLayer.push({

                                    'event': 'updatevirtualpath',
                                    'virtualPageURL': '/careers/contact/confirmation',
                                    'pageCategory': 'lead page',

                                });
                                /* tslint:enable */
                            }

                        } else {
                            $('html, body').animate({
                                scrollTop: $('#career-form').offset().top,
                            }, 2000);
                            $('#error').html(data.html);
                            $('#error').show();
                        }

                        $('#career-form').find('button').removeClass('loading');
                        $('#career-form').find('button').removeAttr('disabled');
                        $('#career-form').find('button').html('<span>Submit</span>');
                    }
                };
                xhttp.open('POST', ajax_url, true);
                xhttp.send(formData);
            });
        }

        if ($('.template-contact-us').length > 0) {
            $('#contact-form').on('submit', function (e) {
                e.preventDefault();
                $('#error').hide();
                $('#success').hide();
                $('#contact-form').find('button').addClass('loading');
                $('#contact-form').find('button').attr('disabled', true);
                $('#contact-form').find('button').html('<span>Submiting</span>');
                var formData = new FormData($('#contact-form')[0]);
                let city = formData.get('city');
                let otherCity = formData.get('other-city');
                if(city == 'other'){
                    formData.delete('city');
                    formData.delete('other-city');
                    formData.append('city',otherCity);
                    formData.append('other-city',true);
                }

                formData.append('action', 'contactUsCallback');
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {
                        // eslint-disable-next-line no-undef
                        grecaptcha.reset();
                        var data = JSON.parse(this.responseText);
                        if (data.status == 1 || data.status == '1') {
                            $('#success').html(data.message);
                            $('#success').show();
                            $('#contact-form')[0].reset();
                            //contact us event trigger implementation
                            if ($('.template-contact-us').length > 0) {
                                /* tslint:disable */
                                window.dataLayer.push({

                                    'event': 'updatevirtualpath',
                                    'virtualPageURL': '/contact-us/confirmation',
                                    'pageCategory': 'lead page',

                                });
                                /* tslint:enable */
                            }


                        } else {
                            $('html, body').animate({
                                scrollTop: $('#contact-form').offset().top,
                            }, 2000);
                            $('#error').html(data.html);
                            $('#error').show();
                        }

                        $('#contact-form').find('button').removeClass('loading');
                        $('#contact-form').find('button').removeAttr('disabled');
                        $('#contact-form').find('button').html('<span>Submit</span>');
                    }
                };
                xhttp.open('POST', ajax_url, true);
                xhttp.send(formData);
            });
        }

        if ($('.template-customer-feedback').length > 0) {
            $('#customer-feedback-form').on('submit', function (e) {
                e.preventDefault();
                $('#error').hide();
                $('#success').hide();
                $('#customer-feedback-form').find('button').addClass('loading');
                $('#customer-feedback-form').find('button').attr('disabled', true);
                $('#customer-feedback-form').find('button').html('<span>Submiting</span>');
                var formData = new FormData($('#customer-feedback-form')[0]);
                formData.append('action', 'customerFeedback');
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {
                        // eslint-disable-next-line no-undef
                        grecaptcha.reset();
                        var data = JSON.parse(this.responseText);
                        if (data.status == 1 || data.status == '1') {
                            $('#success').html(data.message);
                            $('#success').show();
                            $('#customer-feedback-form')[0].reset();
                            //contact us event trigger implementation
                            if ($('.template-customer-feedback').length > 0) {
                                /* tslint:disable */
                                window.dataLayer.push({

                                    'event': 'updatevirtualpath',
                                    'virtualPageURL': '/contact-us/confirmation',
                                    'pageCategory': 'lead page',

                                });
                                /* tslint:enable */
                            }


                        } else {
                            $('html, body').animate({
                                scrollTop: $('#customer-feedback-form').offset().top,
                            }, 2000);
                            $('#error').html(data.html);
                            $('#error').show();
                        }

                        $('#customer-feedback-form').find('button').removeClass('loading');
                        $('#customer-feedback-form').find('button').removeAttr('disabled');
                        $('#customer-feedback-form').find('button').html('<span>Submit</span>');
                    }
                };
                xhttp.open('POST', ajax_url, true);
                xhttp.send(formData);
            });
        }

        if ($('.template-booking').length > 0) {
            $('#online-booking-form').on('submit', function (e) {
                e.preventDefault();
                $('#error').hide();
                $('#success').hide();
                $('#online-booking-form').find('button').addClass('loading');
                $('#online-booking-form').find('button').attr('disabled', true);
                $('#online-booking-form').find('button').html('<span>Submiting</span>');
                var formData = new FormData($('#online-booking-form')[0]);
                // Log each key-value pair in the FormData object
                let city = formData.get('city');
                let otherCity = formData.get('other-city');
                if(city == 'other'){
                    formData.delete('city');
                    formData.delete('other-city');
                    formData.append('city',otherCity);
                    formData.append('other-city',true);
                }
                formData.append('action', 'onlineBooking');
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {
                        // eslint-disable-next-line no-undef
                        grecaptcha.reset();
                        var data = JSON.parse(this.responseText);
                        if (data.status == 1 || data.status == '1') {
                            $('#success').html(data.message);
                            $('#success').show();
                            $('#online-booking-form')[0].reset();
                        } else {
                            $('html, body').animate({
                                scrollTop: $('#online-booking-form').offset().top,
                            }, 2000);
                            $('#error').html(data.html);
                            $('#error').show();
                        }

                        $('#online-booking-form').find('button').removeClass('loading');
                        $('#online-booking-form').find('button').removeAttr('disabled');
                        $('#online-booking-form').find('button').html('<span>Submit</span>');
                    }
                };
                xhttp.open('POST', ajax_url, true);
                xhttp.send(formData);
            });
        }

        if ($('.template-dealership').length > 0) {
            $('#DealerShipApplication').on('submit', function (e) {
                e.preventDefault();
                $('#error').hide();
                $('#success').hide();
                $('#DealerShipApplication').find('button').addClass('loading');
                $('#DealerShipApplication').find('button').attr('disabled', true);
                $('#DealerShipApplication').find('button').html('<span>Submiting</span>');
                var formData = new FormData($('#DealerShipApplication')[0]);
                formData.append('action', 'dealerShipAplication');
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {
                        var data = JSON.parse(this.responseText);
                        // eslint-disable-next-line no-undef
                        grecaptcha.reset();
                        if (data.status == 1 || data.status == '1') {
                            $('#success').html(data.message);
                            $('#success').show();
                        } else {
                            $('html, body').animate({
                                scrollTop: $('#DealerShipApplication').offset().top,
                            }, 2000);
                            $('#error').html(data.html);
                            $('#error').show();
                        }

                        $('#DealerShipApplication').find('button').removeClass('loading');
                        $('#DealerShipApplication').find('button').removeAttr('disabled');
                        $('#DealerShipApplication').find('button').html('<span>Submit</span>');
                    }
                };
                xhttp.open('POST', ajax_url, true);
                xhttp.send(formData);
            });
        }
        //contact us page tag implementation
        if ($('.template-contact-us').length > 0) {
            /* tslint:disable */
            window.dataLayer.push({

                'brand': 'peugeot',
                'virtualPageURL': '/contact-us',
                'language': 'en',
                'country': 'pk',
                'siteTypeLevel1': 'www.peugeot-luckymotorcorp.com',
                'siteTypeLevel2': 'showroom',
                'siteOwner': 'local',
                'siteTarget': 'B2C',
                'siteFamily': 'new cars',
                'pageCategory': 'form page',
            });
            /* tslint:enable */
        }

        //career page tag implementation
        if ($('.template-career').length > 0) {
            /* tslint:disable */
            window.dataLayer.push({

                'brand': 'peugeot',
                'virtualPageURL': '/careers',
                'language': 'en',
                'country': 'pk',
                'siteTypeLevel1': 'www.peugeot-luckymotorcorp.com',
                'siteTypeLevel2': 'others',
                'siteOwner': 'local',
                'siteTarget': 'B2C',
                'siteFamily': 'new cars',
                'pageCategory': 'form page',
            });
            /* tslint:enable */
        }
        // Click on logo tag implementation 1
        $('.main-header .brand', '.main-header .brand-small', 'footer .footer-link-section .footer-logo a').on('click', function () {
            /* tslint:disable */
            window.dataLayer.push({
                'event': 'uaevent',
                'eventCategory': 'Logo',
                'eventAction': 'Redirection::Homepage',
                'eventLabel': 'Icon',
            });


            /* tslint:enable */
        });


        // Click on contact us page tag implementation 2
        $('.main-header .nav-primary .primary-menu .main-navigation .contact-us').on('click', function () {
            /* tslint:disable */
            window.dataLayer.push({
                'event': 'uaevent',
                'eventCategory': 'Header',
                'eventAction': 'Redirection::Forms::Contact',
                'eventLabel': 'Contact us',

            });

            /* tslint:enable */
        });
        // Click on find a dealer page tag implementation 3
        $('.main-header .nav-primary .external-links a').on('click', function () {
            /* tslint:disable */
            window.dataLayer.push({
                'event': 'uaevent',
                'eventCategory': 'Header',
                'eventAction': 'Redirection::Internal::Location',
                'eventLabel': 'Find a Dealer',
            });

            /* tslint:enable */
        });


        // Click on find a dealer page tag implementation 6
        $('.footer-top-links li:first,.footer-top-links li:first a').on('click', function () {
            /* tslint:disable */
            window.dataLayer.push({
                'event': 'uaevent',
                'eventCategory': 'Rangebar',
                'eventAction': 'Redirection::Internal::Location',
                'eventLabel': 'Find a Dealer',

            });
            /* tslint:enable */
        });

        // Click on Expandbar find a dealer page tag implementation 4
        $('.dropdown-right-section .card-box:first a').on('click', function () {
            /* tslint:disable */
            window.dataLayer.push({
                'event': 'uaevent',
                'eventCategory': 'Header::Expandbar',
                'eventAction': 'Redirection::Internal::Location',
                'eventLabel': 'Find a Dealer',

            });
            /* tslint:enable */
        });


        // Click on find a dealer page tag implementation 5
        $('.footer-top-links li:last,.footer-top-links li:last a').on('click', function () {
            /* tslint:disable */
            window.dataLayer.push({
                'event': 'uaevent',
                'eventCategory': 'Rangebar',
                'eventAction': 'Redirection::Forms::Contact',
                'eventLabel': 'Contact us',

            });
            /* tslint:enable */
        });

        if ($('.template-find-retailer').length > 0) {
            window.dataLayer.push({

                'brand': 'peugeot',
                'virtualPageURL': '/find-a-dealer/',
                'language': 'en',
                'country': 'pk',
                'siteTypeLevel1': 'www.peugeot-luckymotorcorp.com',
                'siteTypeLevel2': 'dealer locator',
                'siteOwner': 'local',
                'siteTarget': 'B2C',
                'siteFamily': 'new cars',
                'pageCategory': 'dealer locator page',
            });
        }


        // all pages
        setTimeout(function () {
            window.dataLayer.push({

                'brand': 'peugeot',
                'virtualPageURL': window.location.href,
                'language': 'en',
                'country': 'pk',
                'siteTypeLevel1': 'www.peugeot-luckymotorcorp.com',
                'siteTypeLevel2': 'others',
                'siteOwner': 'local',
                'siteTarget': 'B2C',
                'siteFamily': 'new cars',
            });

        }, 100);

    },
    finalize() {
        this.animateToTarget(undefined, this);
        $('body').on('click', '.primary-menu .toggle-menu-dropdown', function (e) {
            if ($(this).closest('li').hasClass('menu-has-child')) {
                e.preventDefault();
                $('.car-model-dropdown').fadeOut();
                $('.car-model-dropdown[data-parent_id="' + $(this).data('item_id') + '"]').slideDown();
                $('header').addClass('dropdown-open');
                $('.back-first-level').addClass('active');
                $('.hamburger-menu').fadeOut();
            }
        });
        $('body').on('click', '.car-model-dropdown .close-button', function (e) {
            e.preventDefault();
            $('.car-model-dropdown').slideUp().removeClass('active');
            setTimeout(function () {
                $('header').removeClass('dropdown-open');
            }, 800);
        });
        $('body').on('click', '.car-model-dropdown .models-categories', function (e) {
            e.preventDefault();
            $(this).closest('.car-model-dropdown').find('[data-target_model_category]').removeClass('active');
            $(this).addClass('active');
            $(this).closest('.car-model-dropdown').find('[data-model_category]').hide();
            $(this).closest('.car-model-dropdown').find('[data-model_category="' + $(this).data('target_model_category') + '"]').fadeIn();
        });
    },
    animateToTarget($target, $trigger) {
        setTimeout(() => {
            $target = (typeof $target !== 'undefined') ? $target : window.location.hash;
            if ($($target).length) {
                $('html,body').animate({
                    scrollTop: $($target).offset().top - 140,
                }, 500);
                if ($($trigger).parent('li').length) {
                    $($trigger).parent('li').siblings().removeClass('active');
                    $($trigger).parent('li').addClass('active');
                } else if ($('a[href="' + $target + '"]').parent('li').length) {
                    $('a[href="' + $target + '"]').parent('li').siblings().removeClass('active');
                    $('a[href="' + $target + '"]').parent('li').addClass('active');
                }
                window.location.hash = $target;
            }
        }, 200);
    },
};
export function initSlickSlider($obj, $options) {
    if ($obj.length) {
        var $pagingStatus = $obj.prev('.pagingInfo');
        $obj.on('init reInit afterChange', function (event, slick, currentSlide) {
            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            var i = (currentSlide ? currentSlide : 0) + 1;
            $pagingStatus.text(i + '/' + slick.slideCount);
        });
        $obj.slick($options);
    }
}
export function onScrollActivator($obj) {
    // Cache selectors
    var topMenu = $obj,
        topMenuHeight = topMenu.outerHeight() + 15,
        // All list items
        menuItems = topMenu.find('a'),
        // Anchors corresponding to menu items
        scrollItems = menuItems.map(function () {
            if (!$(this).hasClass('brochure')) {
                var item = $($(this).attr('href'));
                if (item.length > 0) { return item; }
            }

        });

    // Bind to scroll
    $(window).scroll(function () {
        // Get container scroll position
        var fromTop = $(this).scrollTop() + topMenuHeight;

        // Get id of current scroll item
        var cur = scrollItems.map(function () {
            if ($(this).offset().top < fromTop)
                return this;
        });
        // Get the id of the current element
        cur = cur[cur.length - 1];
        var id = cur && cur.length ? cur[0].id : '';
        // Set/remove active class
        menuItems
            .parent().removeClass('active')
            .end().filter('[href="#' + id + '"]').parent().addClass('active');
    });
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js